module.exports = __webpack_public_path__ + "img/banner.adfb8e28.png";